var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounSound783004(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,6C25.699,6,6,25.699,6,50s19.699,44,44,44s44-19.699,44-44S74.301,6,50,6z M42,72L30,60H18V40h12l12-12V72z    M51.606,60.606l-2.828-2.828C50.856,55.7,52,52.938,52,50c0-2.938-1.144-5.701-3.222-7.778l2.828-2.828   C54.439,42.227,56,45.993,56,50S54.439,57.773,51.606,60.606z M57.264,66.264c8.968-8.968,8.968-23.559,0-32.527l2.828-2.828   c10.527,10.527,10.527,27.656,0,38.184L57.264,66.264z M68.577,77.577l-2.828-2.828c13.646-13.646,13.646-35.851,0-49.498   l2.828-2.828C83.783,37.629,83.783,62.371,68.577,77.577z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounSound783004);
export default __webpack_public_path__ + "static/media/noun_Sound_783004.cfb9d64a.svg";
export { ForwardRef as ReactComponent };